import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import type { CacheLifecycle } from '@/lib/storage/scopedCache';
import { selectUserId } from '@/redux/user/selectors';

interface CacheBootstrapProps {
  caches: readonly CacheLifecycle[];
}

export const CacheBootstrap = ({ caches }: CacheBootstrapProps) => {
  const userId = useSelector(selectUserId);

  useEffect(() => {
    if (!userId) {
      return;
    }
    const run = () => {
      for (const cache of caches) {
        cache.upgrade(userId);
        cache.sweep(userId);
      }
    };
    if (typeof requestIdleCallback === 'function') {
      const idleId = requestIdleCallback(run);
      return () => cancelIdleCallback(idleId);
    }
    const timeoutId = setTimeout(run, 0);
    return () => clearTimeout(timeoutId);
  }, [userId, caches]);

  return null;
};
